import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  Type,
} from '@angular/core';
import {
  IconDynamicColors,
  IconDynamicData,
  IconDynamicHeadsetComponent,
  IconDynamicHeartInHandComponent,
  IconDynamicStethoscopeComponent,
  OmniAnalyticsService,
  getConversationType,
} from '@cigna/omni/shared';
import { OmniChatFacade } from '@cigna/omni/chat-state';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state';
import { ConversationDTO } from '@cigna/vampire-dto';
import { FeatureTogglesFacade } from '@cigna/features';
import { take } from 'rxjs/operators';

@Component({
  selector: 'cigna-omni-conversation-summary-card',
  templateUrl: './omni-conversation-summary-card.component.html',
  styleUrls: ['./omni-conversation-summary-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OmniConversationSummaryCardComponent {
  @Input()
  public body?: string;

  @Input()
  public chevronColor: IconDynamicColors;

  @Input()
  public conversationId: string;

  @Input()
  public icon: Type<
    | IconDynamicHeadsetComponent
    | IconDynamicHeartInHandComponent
    | IconDynamicStethoscopeComponent
  >;

  @Input()
  public iconColors: IconDynamicColors;

  @Input()
  public iconData?: IconDynamicData;

  @Input()
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public newMessages: boolean;

  @Input()
  public subject: string;

  @Input()
  public isClosed: boolean;

  @Input()
  public date: string;

  @Input()
  public state: string;

  @Input()
  public context: ConversationDTO['context'];

  @Output()
  public interaction: EventEmitter<void> = new EventEmitter();
  isEvernorth: boolean;
  canUpdateAnalyticsData: boolean;
  public shouldEnablePreChatWelcome$ = this.featureToggleFacade.featuresEnabled(
    ['enableNewPreChatWelcome'],
  );

  public onClick(): void {
    this.conversationsFacade.setConversationId(this.conversationId);
    this.chatFacade.openDialog();

    if (!this.canUpdateAnalyticsData) {
      this.analytics.track('viewChat', {
        newMessages: this.newMessages,
        chatState: this.state,
      });

      if (this.newMessages && getConversationType(this.context) === 'DM') {
        this.analytics.trackEvent('viewNewMessage', {
          chatContext: this.context,
        });
      }

      if (this.isEvernorth) {
        this.analytics.trackEvent('chatConversationHistoryView', {
          linkText: 'Open Conversation History Item',
        });
      }
    }
  }

  constructor(
    private chatFacade: OmniChatFacade,
    private conversationsFacade: OmniConversationsFacade,
    private analytics: OmniAnalyticsService,
    private featureToggleFacade: FeatureTogglesFacade,
  ) {
    this.featureToggleFacade
      .featuresEnabled(['isEvernorthEnabled'])
      .pipe(take(2))
      .subscribe((isEvm) => {
        this.isEvernorth = isEvm;
      });
    this.featureToggleFacade
      .featuresEnabled(['canUpdateAnalyticsData'])
      .pipe(take(2))
      .subscribe((canUpdateAnalyticsData) => {
        this.canUpdateAnalyticsData = canUpdateAnalyticsData;
      });
  }
}
